import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Col, Container, Form, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { Chip } from '@mui/material';
import Select from 'react-select';
import RHTextarea from '../../FunctionalComponent/FormElement/RHTextarea';
import { useCreate_Update_faqMutation, useFaqlistQuery } from '../../Redux/faqSlice';
import { getQueryString } from '../../lib/Validationtext';
import BreadCrumb from '../../Common/BreadCrumb';
import { useCreate_Update_returnPolicyMutation, useReturnPolicylistQuery } from '../../Redux/returnPolicy/returnPolicyApi';
import { toast } from 'react-toastify';


function CreateReturnPolicy() {
    const [CreateUpdateReturnPolicyFunc, { isLoading, isSuccess, error, data: responseData }] = useCreate_Update_returnPolicyMutation();
    const { data: listData, isLoading: listLoading } = useReturnPolicylistQuery();
    const [toastId, setToastId] = useState(null)

    console.log(listData, "listData");
    let title = {
        header: `Return Policy ${listData?.response?.id ? 'Update' : 'Add'}`,
        submit: `${listData?.response?.id ? 'Update' : 'Save'}`
    };

    let initialState = {
        id: '',
        level1: '',
        value1: '',
        level2: '',
        value2: '',
    };

    const schema = Yup
        .object({
            level1: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),
            value1: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),

            level2: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),

            value2: Yup
                .string()
                .required()
                .strict(true)
                .trim('White spaces before and after are not allow'),
            // status: Yup.string().required(),
            // status: Yup.string().required('Status is required'),
        })
        .required();

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
        watch
    } = methods;

    const onSubmit = () => {
        const data = getValues();
        const tid = toast.loading("Loading...");
        setToastId(tid)

        CreateUpdateReturnPolicyFunc({ ...data })
    }
    useEffect(() => {
        if (isSuccess) {
            const message = responseData?.message || "Product created successfully";
            toast.update(toastId, {
                render: message,
                type: "success",
                isLoading: false
            })
            reset()
        }
        if (error) {
            if ('data' in error) {
                const errorData = error;
                // toast.error(errorData.responseData.message);
                toast.update(toastId, {
                    render: errorData?.responseData?.message,
                    type: "error",
                    isLoading: false
                })

            }
        }
    }, [responseData, isSuccess, error]);



    useEffect(() => {

        if (listData?.response?.id) {
            Object.keys(initialState).forEach(it => {
                setValue(it, listData?.response?.[it])
            })
        }

    }, [listData?.response])


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <BreadCrumb title={title?.header} pageTitle="More" />

                    <FormProvider className="tablelist-form mt-4" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row>
                            <Col lg={6}>
                                <Row>
                                    <Col xs={12}>
                                        <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                                        <input type="hidden" id="id-field" />
                                        <div className="mb-3">
                                            <RHFTextField name='level1' label='level1' required={true} />
                                        </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <RHTextarea label='Value1' name='value1' placeholder="Value1" rows={3} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={6}>
                                <Row>
                                    <Col xs={12}>
                                        <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                                        <input type="hidden" id="id-field" />
                                        <div className="mb-3">
                                            <RHFTextField name='level2' label='level2' required={true} />
                                        </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <RHTextarea label='Value2' name='value2' placeholder="Value2" rows={3} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} className="modal-footer mt-4">
                                <Row>
                                    <Col lg={12} >
                                        <div className="hstack gap-2 justify-content-end">
                                            <Button variant='primary' id="add-btn" type="submit">{title?.submit}</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </FormProvider>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default CreateReturnPolicy;
